import { lazy } from "react";
import EventIcon from "@mui/icons-material/Event";
import SettingsIcon from "@mui/icons-material/Settings";

const EventsNotification = lazy(() => import("../index"));

const eventsRoute = {
  icon: SettingsIcon,
  name: "Settings",
  link: "/settings",
  path: "settings",
  index: 25,
  children: [
    {
      icon: EventIcon,
      name: "Events Notification",
      link: "settings/events-notification",
      path: "events-notification",
      element: <EventsNotification />,
      permission: "Event-Create",
      index: 6,
    },
  ],
};

export default eventsRoute;